export const OPEN_ADD_CUSTOMER_JOTR_MODAL = 'OPEN_ADD_CUSTOMER_JOTR_MODAL';
export const CLOSE_ADD_CUSTOMER_JOTR_MODAL = 'CLOSE_ADD_CUSTOMER_JOTR_MODAL';

function open() {
  return {
    type: OPEN_ADD_CUSTOMER_JOTR_MODAL,
  };
}

function close() {
  return {
    type: CLOSE_ADD_CUSTOMER_JOTR_MODAL
  };
}

export function openAddCustomerJotrModal() {
  return (dispatch) => {
    dispatch(open());
  };
}

export function closeAddCustomerJotrModal() {
  return (dispatch) => {
    dispatch(close());
  };
}
